<template>
  <div class="student">
    <el-card class="box-card" style="margin-top: 0px">
      <div style="position:relative;">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="item.label" :name="item.name" v-for="(item, k) in catogeryList" :key="k">
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-form v-if="switchType == '延期记录'" ref="searchForm" :model="searchForm" :label-width="formLabelWidth" style="margin-bottom:10px;">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="4">
            <!-- <el-input type="number" v-model="searchForm.courseId" auto-complete="off"></el-input> -->
            <el-cascader style="width: 100%" clearable collapse-tags v-model="courseIds" :show-all-levels="false" :props="subjectTreeProps" placeholder="请输入所属科目" :options="subjectTreeList" @change="subjectSearchChange"></el-cascader>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <el-input v-model="searchForm.goodsName" placeholder="请输入商品名称" auto-complete="off" clearable></el-input>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <el-input v-model="searchForm.nameAndMobile" placeholder="请输入学员姓名/手机号" auto-complete="off" clearable></el-input>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <el-input v-model="searchForm.orderNumber" placeholder="请输入订单编号" auto-complete="off" clearable></el-input>
          </el-col>
          <el-col :sm="24" :md="6" :lg="6" style="float: right">
            <div style="float: right">
              <!-- <a class="mainColor" @click="reset">重置</a> -->
              <el-button type="primary" @click="(page.pageNumber = 1), pageList()" v-auth="'/goodsInfo/pageList'" icon="el-icon-search">查询</el-button>
            </div>
          </el-col>
        </el-row>

      </el-form>
      <el-table v-if="switchType == '延期记录'" ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" :data="page.rows" tooltip-effect="dark" style="margin-top: 0px; width: 100%" border @selection-change="selectionChange">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="orderNumber" label="订单编号" width="150px"></el-table-column>
        <el-table-column prop="studentName" label="姓名" width="150px"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="150px"></el-table-column>
        <el-table-column prop="goodsName" label="商品" width="150px"></el-table-column>
        <el-table-column prop="sourceType" label="订单来源" width="150"></el-table-column>
        <el-table-column prop="count" label="延期时间" width="180"></el-table-column>
        <el-table-column prop="operator" label="操作人" width="130px"></el-table-column>
        <el-table-column prop="createTime" label="日期" width="200px"></el-table-column>
        <el-table-column prop="remark" label="备注" minwidth="150px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="mainColor" @click="clickRow = scope.row, (editFormVisible = true)">{{ scope.row.remark || '--' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next" style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
    </el-card>

    <el-dialog title="编辑" :visible.sync="editFormVisible" width="50%" left>
      <el-form ref="editForm" :model="editForm" :label-width="formLabelWidth" :rules="editFormRules">
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="24">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" :rows="3" v-model="editForm.remark" placeholder="请输备注" auto-complete="off" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateStudent">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import md5 from "md5";
import { uploadOSS } from "../../upload/upload";
import video from '../classRoomTeaching/video.vue';
export default {
  components: { video },
  data () {
    return {
      loadVideo: false,
      courseIds: [],
      groupList: [],
      subjectList: [],
      campusList: [],
      subjectListVisible: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      viewFormVisible: false,
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      options: [],
      region: [],
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      subjectTreeList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      searchForm: {
        goodsName: "",
        subjectIds: [],
        orderNumber: '',
        nameAndMobile: '',
      },
      regionTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      editForm: {
        remark: '',
      },
      studentDetail: {},
      editFormRules: {
        remark: [
          {
            required: true,
            message: "请输入备注",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "备注长度在1到255个字",
          },
        ],
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      regionList: [],
      ids: [],
      fileAction: `${process.env.BASE_URL}/student/upload`,
      fileList: [],
      studentGroupLIst: [],
      loading: false,
      exportLoading: false,
      activeName: 'first',
      switchType: '全部',
      clickRow: {},
      catogeryList: [
        {
          label: '分享记录',
          name: 'first'
        }, {
          label: '退费记录',
          name: 'second'
        }, {
          label: '延期记录',
          name: 'three'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    },
  },
  methods: {
    getSubjectTreeList () {
      // 获取课程
      this.api.campus.getPermissionSubjectTree().then((result) => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              delete items.children;
            }
          } else {
          }
        }
        this.subjectTreeList = result.data;
      }).catch((error) => {
        console.log(error);
      });
    },
    subjectSearchChange () {
      if (this.courseIds) {
        this.searchForm.subjectIds = [];
        this.courseIds.forEach((item) => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
      console.log(this.searchForm.subjectIds, 'subjectSearchChange');
    },
    addNewPoint () {
      this.addForm = {
        videoUrl: '',
        posterUrl: '',
        remark: '',
        type: '',
      }
      console.log(this.addForm, 'addNewPoint')
    },
    handleClick (e) {
      console.log(e)
      this.switchType = e.label
      this.page.pageNumber = 1;
      if (this.switchType == '延期记录') {
        this.pageList();
      }
    },

    campusChange (val) {
      this.searchForm.campusId = val[2];
    },
    // 是否启用
    updateSwitching (row) {
      var params = {
        enable: row.enable,
        id: row.id
      }
      this.api.classroom.updateKnowledgePoint(params).then((result) => {
        if (result.success) {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.pageList();
        } else {
          this.$message.error(result.message);
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    seeOverviewDetails (obj) {
      this.$router.push(`/studentGoodsContent?id=${obj.id}`);
    },
    importExcel () {
      window.open(
        // "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/student/%E5%AD%A6%E7%94%9F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xls"
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/materials/16190125872036.xls"
      );
    },
    addRegionChange () {
      this.addForm.regionId = this.region[1];
    },
    editRegionChange () {
      this.editForm.regionId = this.region[1];
    },
    getPageList (id) {
      this.api.classroom.getPointList({ id: id })
        .then((result) => {
          if (result.data) {
            this.subjectList = result.data;
          } else {
            this.subjectList = [];
          }
          this.subjectListVisible = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },

    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      console.log("val", val);
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
      console.log("this.ids", this.ids);
    },
    getStudent () {
      console.log(this.clickRow)
      this.editForm = this.clickRow;
      this.editForm.posterUrl = this.clickRow.img
      this.editForm.videoUrl = this.clickRow.url
    },
    getStudentDetail () {
      this.api.student.getStudentDetail({
        id: this.selection,
      }).then((result) => {
        this.studentDetail = result.data;
      }).catch((error) => {
        console.log(error);
      });
    },
    pageList () {
      this.loading = true;
      var params = {
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,
        subjectIds: this.searchForm.subjectIds,
        goodsName: this.searchForm.goodsName,
        orderNumber: this.searchForm.orderNumber,
        nameAndMobile: this.searchForm.nameAndMobile,
      }
      this.api.classroom.getOperationDelayLogData(params).then((result) => {
        this.loading = false;
        this.page.rows = result.data.records;
        this.page.total = result.data.total;
      }).catch((error) => {
        console.log(error);
      });
    },
    addStudent () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          var params = {
            img: this.addForm.posterUrl,
            remark: this.addForm.remark,
            type: this.addForm.type,
            url: this.addForm.videoUrl,
          }
          this.api.classroom.addKnowledgePoint(params).then((result) => {
            if (result.success) {
              this.$message.success(result.message);
              this.addFormVisible = false;
            } else {
              this.$message.error(result.message);
            }
          })
        } else {
          return false;
        }
      });
    },
    updateStudent () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.api.classroom.updateDelayLog({ id: this.clickRow.id, remark: this.editForm.remark }).then((result) => {
            if (result.success) {
              this.$message({
                type: "success",
                message: result.message,
              });
              this.editFormVisible = false;
              this.pageList();
            } else {
              this.$message.error(result.message);
            }
          })
        } else {
          return false;
        }
      });
    },
    deletePoint (obj) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        var params = {
          "id": obj.id,
          "state": -1
        }
        this.api.classroom.updateKnowledgePoint(params).then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        })
      })
    },
    batchDeleteStudent () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.student
            .deleteStudent(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.searchForm.subjectIds = []
      this.$refs.searchForm.resetFields();
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel () {
      this.exportLoading = true;
      setTimeout(() => {
        this.exportLoading = false;
      }, 5000);
      let obj = Object.assign({}, this.searchForm);
      delete obj.createTime;
      this.api.student
        .exportExcel(obj)
        .then((result) => {
          if (result.success) {
            let url = result.data;
            this.$message.success(url);
            this.exportLoading = false;
          } else {
            this.exportLoading = false;
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          this.exportLoading = false;
          console.log(error);
        });
    },
    resetStudentPassword (row) {
      this.$confirm("您确定要重置密码吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.api.student
          .resetStudentPassword({ id: row.id })
          .then((result) => {
            if (result.success) {
              this.$message.success("操作成功，密码为您的手机号！");
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    goOpen (row) {
      this.$router.push({
        path: "/open",
        query: {
          phone: row ? row.account : "",
          id: row ? row.id : "",
        },
      });
    },
    importData () {
      if (this.multipleSelection.length == 0) {
        this.$message("请选择需要导入的学员");
      } else {
        this.api.student
          .importData(this.multipleSelection)
          .then((result) => {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.multipleSelection = [];
            this.pageList();
            this.importFormVisible = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRegionTree () {
      this.api.getRegionTree().then((result) => {
        if (result.success) {
          this.regionList = result.data;
        }
      });
    },
    getStudentGroupList () {
      this.api.student
        .getStudentGroupList({})
        .then((result) => {
          this.groupList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.api.student
        .getStudentFromTypeList({})
        .then((result) => {
          this.options = result.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.api.student
        .getStudentGroupList({})
        .then((result) => {
          this.studentGroupLIst = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkboxT (row, rowIndex) {
      if (row.remark == "") {
        return true;
      } else {
        return false;
      }
    },

  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
      console.log(this.addForm, 'addFormVisible')
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getStudent();
      }
    },
    importFormVisible: function (newVal) {
      if (!newVal) {
        this.importForm = {};
      } else {
      }
    },
    viewFormVisible: function (newVal) {
      if (!newVal) {
        this.studentDetail = {};
        this.$refs.studentDetail.resetFields();
      } else {
        this.getStudentDetail();
      }
    },

  },
  mounted () {
    this.pageList();
    this.getSubjectTreeList()
    this.getStudentGroupList();
    this.getCampusList();
  },
};
</script>
<style scoped>
.addPoint {
  position: absolute;
  right: 0;
  top: 0;

}

.avatar-uploader-logo {
  margin-top: 20px;
}

.avatar-uploader-logo .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-logo .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
}

.avatar {
  width: 60px;
  height: 60px;
  display: block;
}

.currencySetting-image {
  border-radius: 4px;
  vertical-align: bottom;
}

.answer {
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  color: #409eff;
  text-overflow: ellipsis;
}

.courseManage {
  padding: 3px 14px 3px 14px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}

.style1 {
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
}

.style2 {
  background: rgb(255, 185, 28);
  border: solid 1px rgb(255, 185, 28);
}

.style3 {
  background: rgb(162, 170, 188);
  border: solid 1px rgb(162, 170, 188);
}
</style>
<style lang="less">
.student {
  .el-select {
    width: 100% !important;
  }

  .viewForm {
    .el-dialog__body {
      padding-top: 0px;
    }

    .el-form-item {
      margin-bottom: 0px !important;
    }
  }

  .importForm {
    .el-upload-list {
      display: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderInfo/operationLog.vue